import { useCreditCardActions } from "../actions/creditCardActions"
import { useCreditCardBuilders } from "../builders/creditCardBuilders"
import { useCreditCardLoaders } from "../loaders/creditCardLoaders"

export const useCreditCardService = () => {
    const { buildCreditCard } = useCreditCardBuilders()

    const creditCardLoaders = useCreditCardLoaders()

    const { saveCreditCard } = useCreditCardActions()

    const archiveCreditCard = async (creditCardId: string) => {
        const { loadCreditCard } = creditCardLoaders()
        const creditCard = await loadCreditCard(creditCardId, true)
        const archivedCreditCard = buildCreditCard({
            ...creditCard,
            archived: true
        })
        return saveCreditCard(archivedCreditCard)
    }

    return {
        archiveCreditCard
    }
}
